// Set whether notification has been done
var $buo_fourd_notified = false;
// Set options for browser-update.org script
// https://browser-update.org/customize.html
var $buoop = {
    required: {
        e: -36, // Edge
        f: -36, // Firefox
        //o: -3, // Opera
        s: -3, // Safari
        c: -36, // Chrome
        ios: -3 // iOS
    },
    insecure: false, // Show warning if browser insecure
    api: 2025.02,
    onshow: function (infos) { $buo_fourd_notify(infos, true); },
    //no_permanent_hide: true,
    nomessage: true // Do not show a message if the browser is out of date, just call the onshow callback function
    //,test: true // Set to true to test
};
function $buo_fourd_notify(infos, showBanner) {
    if (infos) {
        // Set notified flag to true so that we don't try again
        $buo_fourd_notified = true;
        var browserName = '';
        if (infos.browser && infos.browser.t) { browserName = infos.browser.t; }
        if (showBanner) {
            // Log details so that we know which old browsers are being used
            fourdLogWarning('Legacy browser detected ' + browserName + ' - banner shown', infos);
            // Show banner to warn user that browser is outdated
            var div = document.createElement("div");
            div.className = "banner";
            div.innerHTML = '<p>You are using an <strong>outdated</strong> browser. Please <a href="https://browsehappy.com/">upgrade your browser</a> to improve your experience.</p>';
            document.body.insertBefore(div, document.body.firstChild);
        }
        else {
            // Log details so that we know which old browsers are being used
            fourdLogWarning('Legacy browser detected ' + browserName + ' - banner not shown', infos);
        }
    }
};
function $buo_fourd_browserChecks() {
    // Custom verion of code in browser-update.org check_show function - we want to log details even if the user cannot update
    if (!$buo_fourd_notified) {
        // Notification not yet sent
        if ($buo) {
            // Call the default browser-update.org method first, this should handle most cases
            // NOTE: this step is required when using the npm version of the code which doesn't auto call this method
            $buo($buoop);
        }
    }
    if (!$buo_fourd_notified) {
        // The default check hasn't detected an issue, check for any extra scenarios we want to notify for
        // Get options variable
        var op = $buoop;
        if (op && $bu_) {
            // Do browser check
            var bb = op.browser = $bu_.get_browser(op.override_ua);
            if (!bb.is_supported) {
                // Browser not supported by vendor
                if (bb.no_device_update) {
                    // User unable to update, log details, but do not show banner to user as they can't do anything
                    $buo_fourd_notify(op, false);
                }
                else {
                    // User can update, log details
                    // Don't show banner for now, may want to show in the future
                    $buo_fourd_notify(op, false);
                }
            }
        }
    }
};
function $buo_fourd_loadScript() {
    // Load latest version of browser-update.org script
    var e = document.createElement("script");
    //e.src = "//browser-update.org/update.min.js"; // Unable to specify crossorigin, doesn't auto fire
    // Use CDN - can specify crossorigin
    e.src = "https://cdn.jsdelivr.net/npm/browser-update/update.npm.min.js";
    e.setAttribute('crossorigin', 'anonymous');
    e.setAttribute('onerror', 'fourdHandleScriptLoadError(event)');
    e.setAttribute('onload', '$buo_fourd_browserChecks()');
    document.body.appendChild(e);
};
// Add listeners to trigger browser check function
try { document.addEventListener("DOMContentLoaded", $buo_fourd_loadScript, false) }
catch (e) { window.attachEvent("onload", $buo_fourd_loadScript) }